module.exports = __webpack_public_path__ + "img/signing_agreement.d89c2639.png";